<div class="container">
  <div class="row">
    <div class="col-md-6">
      <div class="outline">
        <div class="header">Recover your Password</div>

        <form (ngSubmit)="onSubmit()" [formGroup]="resetForm">

          <div class="form-group">
            <label for="email">Enter the email address you signed up with</label>
            <input type="text" placeholder="Email" class="form-control" id="reset-email" name="email" formControlName="email" />
          </div>

          <div class="form-group">
            <button
              [disabled]="resetForm.invalid"
              class="pv-button"
              [ngClass]="{ disabled: resetForm.invalid }"
            >
              Recover Password
            </button>
          </div>

          <div class="message accent-color">{{ message }}</div>
        </form>
      </div>
    </div>
  </div>
</div>